var map = {
	"./Nikon_4973.JPG": 814690,
	"./Nikon_4979.JPG": 152056,
	"./Nikon_4983.JPG": 436919,
	"./Nikon_4985.JPG": 628201,
	"./Nikon_4987.JPG": 803131,
	"./Nikon_4988.JPG": 449024,
	"./Nikon_4994.JPG": 985803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468493;